import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { catchError, map, throwError } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CasosExitoService {
  endpointApi = environment.apiCmsCasos;

  casos: any;

  size: number = 10000;
  page: number = 0;

  constructor(private http: HttpClient) { }

  // Handle API errors =================================
  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An client error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.log("Backend error code " + error.status + ", body was: " + JSON.stringify(error.error));
    }
    // return an observable with a user-facing error message
    return throwError(() => error.error)
  }

  getCasosStatic() {
    return this.http.get<any>(this.endpointApi + '/get?id=1')
      .pipe(
        map(resp => {
          return resp.data.cases;
        }),
        catchError(this.handleError)
      );
  }

  getCasosExitoItems() {
    this.casos = this.http.get<any>(this.endpointApi + '/list?size=' + this.size)
      .pipe(
        map(resp => {
          return resp;
        }),
        catchError(this.handleError)
      )

    return this.casos;
  }

}
